import { useEffect, useState } from "react";

/** Current time, re-read every `intervalMs` so "today", overdue flags and day ranges follow the clock. */
export const useNow = (intervalMs = 60_000): Date => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
};
